import { useEffect, useState } from 'react'

/**
 * Keep an element mounted through its close animation.
 * `visible` lags one frame behind `open` so CSS transitions can run.
 */
export function useAnimatedPresence(open: boolean, durationMs = 200) {
  const [mounted, setMounted] = useState(open)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const ms = reduced ? 0 : durationMs

    if (open) {
      setMounted(true)
      let frame2 = 0
      const frame1 = window.requestAnimationFrame(() => {
        if (ms === 0) {
          setVisible(true)
          return
        }
        frame2 = window.requestAnimationFrame(() => setVisible(true))
      })
      return () => {
        window.cancelAnimationFrame(frame1)
        window.cancelAnimationFrame(frame2)
      }
    }

    setVisible(false)
    const t = window.setTimeout(() => setMounted(false), ms)
    return () => window.clearTimeout(t)
  }, [open, durationMs])

  return { mounted, visible }
}
